import { Component, Input, Output, OnInit, OnChanges, SimpleChanges, EventEmitter } from "@angular/core";

import { CronOptions } from "../insa-cron-assets/CronOptions";
import { Days, MonthWeeks, Months } from "../insa-cron-assets/enums";



@Component({
    selector: "insa-cron",
    template: require("./insa-cron.component.html"),
    styles: [require("./insa-cron.component.css").toString()]
})
export class InsaCronComponent {
    public cronExpression = "8 0/11 * 1/1 * ? *";
    public isCronDisabled = false;
    public cronOptions: CronOptions = {
        formInputClass: 'form-control cron-editor-input',
        formSelectClass: 'form-control cron-editor-select',
      formRadioClass: 'cron-editor-radio',
      formCheckboxClass: 'cron-editor-checkbox',
      
      defaultTime: "10:00:00",
      
      hideMinutesTab: true,
      hideHourlyTab: true,
      hideDailyTab: true,
      hideWeeklyTab: true,
      hideMonthlyTab: true,
      hideYearlyTab: true,
      hideAdvancedTab: true,
      hideLogTableTab: false,
      hideChronosJobTableTab: false,
      hideTaskListTab: false,
      use24HourTime: true,
      hideSeconds: true
    };  
}


// WEBPACK FOOTER //
// ./app/insa-components/insa-cron/insa-cron-main/insa-cron.component.ts